import React from 'react';
import { Container } from 'react-bootstrap';
import { services } from '../data/content';

const Services = () => {
  return (
    <section id="services" className="section bg-light">
      <Container>
        <div className="section-title">
          <h2>What We Offer</h2>
        </div>
        <div className="services-grid stagger-children">
          {services.map(service => (
            <div className="services-card" key={service.id}>
              <div className="icon"><service.icon /></div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Services;
